import { toast } from "react-toastify";

export const toastMessage = (message:string, type = "error") => {
  //@ts-ignore
  return toast[type](message, {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};
